import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';
import { serializer } from './serializer';

let initedIntervalRefresh = false
bus.on(constants.EVENTS.APP.READY, refreshAppData);
bus.on(constants.EVENTS.APP.READY, () => {
  if (initedIntervalRefresh) return;
  initedIntervalRefresh = true;
  setInterval(() => {
    refreshAppData();
  }, 5000);
});
bus.on(constants.EVENTS.APP_DATA.REFRESH, refreshAppData);

function refreshAppData() {
  const requestId = `appdata-${Date.now()}`;
  bus.emit(EVENTS.APP_DATA.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: `${constants.ENDPOINTS.APP_DATA.GET}`,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(EVENTS.APP_DATA.REFRESHED, parsed.data);
      } else {
        bus.emit(EVENTS.APP_DATA.REFRESH_ERROR, parsed);
      }
    }
  });
}
